/*
 *******************************************************************************
 * 
 *  Filename:   ./reducers/NavTypes.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Reducers for Nav Types
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *  
 *  Created:    Saturday, September 15, 2018 - 10:05 PM (CST)
 *  
 *  Notes:
 *      09/15/2018  NJN     Working on clean up to split out or eliminate code.
 *  
 *  Revisions:
 *      09/15/2018  NJN     File Created
 *      
 *      
 *  Copyright (c) 2018 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import {
    NAVTYPE_LIST_CONTAINER_LOADED,
    NAVTYPE_LIST_CONTAINER_UNLOADED,
    NAVTYPE_LIST_TABLE_LOADED,
    NAVTYPE_LIST_TABLE_UNLOADED,
    NAVTYPE_SELECT_ROW,
    NAVTYPE_ADD,
    NAVTYPE_EDIT,
    NAVTYPE_DELETE,
    NAVTYPE_OPEN_WARNING,
    NAVTYPE_CLOSE_WARNING,
    NAVTYPE_EDIT_CONTAINER_LOADED,
    NAVTYPE_EDIT_CONTAINER_UNLOADED,
    NAVTYPE_EDIT_FORM_LOADED,
    NAVTYPE_EDIT_FORM_UNLOADED,
    NAVTYPE_EDIT_DATA_LOAD,
    NAVTYPE_EDIT_CONTAINER_SUBMIT,
    NAVTYPE_EDIT_CONTAINER_CANCEL
} from '../constants/actionTypeNavTypes';

const defaultState = {
    refreshList: false,
    navtypes: [],
    danger: false,
    navtypeid: 0,
    name: '',
    description: '',
    createdate: '',
    modifydate: ''
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case NAVTYPE_LIST_CONTAINER_LOADED:
            return {
                ...state,
                inProgress: false,
                errors: action.error ? action.payload.errors : null,
                navtypes: action.payload ? action.payload.navtypes : []
            }
        case NAVTYPE_LIST_TABLE_LOADED:
            return {
                ...state
            }
        case NAVTYPE_SELECT_ROW:
            return {
                ...state,
                navtypeid: action.id
            }
        case NAVTYPE_ADD:
            return {
                ...state
            }
        case NAVTYPE_EDIT:
            return {
                ...state,
                navtypeid: action.id
            }
        case NAVTYPE_DELETE:
            return {
                ...state,
                navtypeid: null
            }
        case NAVTYPE_OPEN_WARNING:
            return {
                ...state,
                danger: true
            }
        case NAVTYPE_CLOSE_WARNING:
            return {
                ...state,
                danger: false
            }
        case NAVTYPE_EDIT_CONTAINER_LOADED:
        case NAVTYPE_EDIT_DATA_LOAD:
            return {
                ...state,
                navtypeid: action.payload ? action.payload.navtypeid : 0,
                name: action.payload ? action.payload.name : '',
                description: action.payload ? action.payload.description : '',
                createdate: action.payload ? action.payload.createdate : '',
                modifydate: action.payload ? action.payload.modifydate : ''
            }
        case NAVTYPE_EDIT_FORM_LOADED:
            return {
                ...state
            }
        case NAVTYPE_EDIT_CONTAINER_SUBMIT:
            return {
                ...state
            }
        case NAVTYPE_EDIT_CONTAINER_CANCEL:
            return {
                ...state
            }
        case NAVTYPE_LIST_CONTAINER_UNLOADED:
        case NAVTYPE_LIST_TABLE_UNLOADED:
        case NAVTYPE_EDIT_CONTAINER_UNLOADED:
        case NAVTYPE_EDIT_FORM_UNLOADED:
            return {};
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/NavTypes.js